import { supabase } from '@/integrations/supabase/client';

/**
 * Ensures a user profile exists in the database
 * If it doesn't exist, creates it automatically
 */
export async function ensureProfile(userId: string, email?: string) {
  try {
    console.log('Ensuring profile exists for user:', userId);

    // Try to fetch existing profile
    const { data: existingProfile, error: fetchError } = await supabase
      .from('profiles')
      .select('id')
      .eq('id', userId)
      .single();

    // If profile exists, we're good
    if (existingProfile) {
      console.log('Profile already exists');
      return existingProfile;
    }

    // If error is "not found", we need to create it
    if (fetchError?.code === 'PGRST116') {
      console.log('Profile not found, creating new profile...');

      const { data: newProfile, error: createError } = await supabase
        .from('profiles')
        .insert([
          {
            id: userId,
            email: email || null,
            phone: null,
            role: 'user',
            balance: 0,
            kyc_status: 'pending',
            currency: 'USD',
          },
        ])
        .select()
        .single();

      if (createError) {
        console.error('Error creating profile:', createError);
        throw createError;
      }

      console.log('Profile created successfully:', newProfile);
      return newProfile;
    }

    // Some other error occurred
    if (fetchError) {
      console.error('Error checking profile:', fetchError);
      throw fetchError;
    }

  } catch (error) {
    console.error('ensureProfile error:', error);
    throw error;
  }
}
